export type Page = "feed" | "about" | "post";

export type RouteState = {
  page: Page;
  postId: string | null;
};

const extractPostId = (slug: string): string | null => {
  const parts = slug.split("-");

  for (let index = parts.length - 1; index >= 0; index -= 1) {
    const part = parts[index];
    if (part && /^\d+$/.test(part) && part.length > 10) {
      return part;
    }
  }

  return null;
};

export const routeFromPath = (pathname: string): RouteState => {
  if (pathname.startsWith("/posts/")) {
    const slug = pathname.slice("/posts/".length).replace(/\/$/, "").replace(/\.html$/, "");
    return { page: "post", postId: extractPostId(slug) };
  }

  if (pathname === "/about" || pathname === "/about/") {
    return { page: "about", postId: null };
  }

  return { page: "feed", postId: null };
};
